import styled from '@emotion/styled';

export const Row = styled('tr')`
  min-height: 200px;

  ul {
    padding: 0;
    margin: 0;
  }

  .td-logo {
    width: 80px;
    text-align: center;

    div {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      row-gap: 16px;

      span {
        font-size: 20px;
        font-weight: 700;
      }
    }

    @media (max-width: 800px) {
      div {
        img {
          width: 120px;
        }
      }
    }
  }

  .td-name {
    width: 100px;
    text-align: left;

    span {
      margin-left: 8px;
    }
  }
`;
